import type { ActivationAction } from '@modules/shared-types';
import { SHORT_FORM_COPY } from '../copy/shortFormCopy';

/** One sentence naming WHERE the action lands (AC-031, DC-16): canvas / here / page name / vendor. */
export function describeActionLanding(action: ActivationAction): string {
  switch (action.class) {
    case 'C': return SHORT_FORM_COPY.landing.C;
    case 'D': return SHORT_FORM_COPY.landing.D;
    case 'P': return SHORT_FORM_COPY.landing.P(action.label);
    case 'X': return SHORT_FORM_COPY.landing.X(action.label);
  }
}

/** Primary button verb — the label itself already names the destination in the detail line. */
export function actionVerb(action: ActivationAction): string {
  return SHORT_FORM_COPY.actionVerb[action.class];
}

/** The full checklist page (App.jsx:428 `/project/:projectId/launch`). */
export function fullListPath(projectId: string): string {
  return `/project/${projectId}/launch`;
}
